import { Display3, SkeletonText, YStack } from "@medbillai/ui";
import { useAuth } from "../../../lib/auth";

// The profile exposes `name`, not a discrete first name, so take the first token.
const firstNameOf = (name: string | undefined): string | undefined => {
  const first = name?.trim().split(/\s+/)[0];
  return first ? first : undefined;
};
export type GreetingHeaderProps = {
  loading?: boolean;
};
export function GreetingHeader({
  loading = false
}: GreetingHeaderProps) {
  const {
    user
  } = useAuth();
  const firstName = firstNameOf(user?.profile?.name);
  const greeting = firstName ? `Hello ${firstName},` : "Welcome,";
  return <YStack aria-busy={loading || undefined} data-sentry-element="YStack" data-sentry-component="GreetingHeader" data-sentry-source-file="GreetingHeader.tsx">
      <SkeletonText loading={loading} chars={10} data-sentry-element="SkeletonText" data-sentry-source-file="GreetingHeader.tsx">
        <Display3 color="$textDefault" data-sentry-element="Display3" data-sentry-source-file="GreetingHeader.tsx">{greeting}</Display3>
      </SkeletonText>
      <SkeletonText loading={loading} chars={18} data-sentry-element="SkeletonText" data-sentry-source-file="GreetingHeader.tsx">
        <Display3 color="$textSubtle" data-sentry-element="Display3" data-sentry-source-file="GreetingHeader.tsx">How can Granted help?</Display3>
      </SkeletonText>
    </YStack>;
}